<template>
    <div v-if="filtersCaption">
        <p class="vehicle-alerts-section-title">Summary</p>

        <div class="summary-banner">
            <div>
                <img src="@/assets/img/notification-bell.svg" alt="" height="20">
            </div>
            <div class="vehicle-alerts-summary-text" v-html="filtersCaption"></div>
        </div>
    </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useStore } from '@/store';

export default defineComponent({
    name: 'SummaryContainer',
    setup () {
        const store = useStore();
        const filtersCaption = computed(() => store.getters.selectedFiltersCaption);

        return {
            filtersCaption
        };
    }
});
</script>

<style scoped>
.vehicle-alerts-summary-text {
    min-height: 20px;
    margin: 0 0 0 2rem;
}
.summary-banner {
    width: 100%;
    padding: 1.5rem;
    background: #f5f6f6;
    display: inline-flex;
    justify-content: flex-start;
    border-radius: 6px;
}
</style>
